import { flatSx, FlexColumn } from '@ocodelib/mui';
import { Box, type SxProps } from '@mui/material';
import { CodeEditorBox } from './CodeEditorBox';

interface Props {
  sx?: SxProps;
}

export function LayoutLeftPane(props: Props) {
  const { sx } = props;

  return (
    <FlexColumn
      className="LayoutLeftPane-root"
      sx={flatSx(
        {
          height: '100%',
        },
        sx,
      )}
    >
      <CodeEditorBox sx={{ flex: 1 }} />
    </FlexColumn>
  );
}
